<template>
  <div>
    <v-layout>
      <v-flex xs1 style="margin-left: 20px;">
        <AppForm :label="subCategoryName" />
      </v-flex>
      <v-flex xs1 ml-3 mt-1>
        <v-icon @click="removeSubcategory(condition.poiSubCategoryId)">
          mdi-close-circle-outline
        </v-icon>
      </v-flex>
    </v-layout>
    <v-layout v-if="condition.type == 'select'" style="margin-left: 20px;">
      <v-chip
        v-for="idAndName in condition.idsAndNames"
        :key="idAndName.id"
        @input="removeSubcategoryValue(condition, idAndName.id)"
        small
        outline
        close
        color="blue"
      >
        {{ idAndName.name }}
      </v-chip>
    </v-layout>
    <v-layout v-if="condition.type == 'number'">
      <v-flex xs1 ml-3 mt-3>
        <span>{{ condition.value }}</span>
      </v-flex>
      <v-flex xs1 mt-3>
        <span>{{ translateToJapanese(condition.condition) }}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'POISearchCondition',
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
    subCategoryName: {
      type: String,
      default: '',
    },
    condition: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    removeSubcategory(subcategoryId) {
      this.$emit('removeSubcategory', subcategoryId)
    },
    removeSubcategoryValue(condition, subcategoryValueId) {
      condition.removeSubcategoryValue(subcategoryValueId)
      if (condition.valueIds.length === 0) {
        this.removeSubcategory(condition.poiSubCategoryId)
      }
    },
    translateToJapanese(greaterOrLess) {
      if (greaterOrLess === 'less') return '以下'
      if (greaterOrLess === 'greater') return '以上'
      return ''
    },
  },
}
</script>
